
<div class="p-2 busy-overlay-parent" [ngClass]="isLoading?'disabled':''">

    <div *ngIf="isLoading || bSyncing" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Syncing Paths...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
        {{errorMsg}}
        <div role="button" (click)="errorMsg=''"><i class="fa fa-times"></i></div>
    </div>

    <div *fesListView="let filteredPaths of rxPaths">
        <h5>RxDB Paths</h5>
        <div class="d-flex">
            <button class="btn btn-secondary btn-sm m-1 mr-auto" (click)="clearPaths()">Rebuild</button>
            <a href="javascript:false;" (click)="loadPaths()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
        </div>
        <table class="table table-striped table-bordered table-sm">
            <thead>
                <tr>
                    <th fesSortField="id">pathId</th>
                    <th fesSortField="buildingId">buildingId</th>
                    <th fesSortField="description">description</th>
                    <th fesSortField="updatedAt">updatedAt</th>
                    <th class = "d-none" fesSortField="_rev">_rev</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><input fesFilterField="id"class="small w-100" /></td>
                    <td><input fesFilterField="buildingId"class="small w-100" /></td>
                    <td><input fesFilterField="description"class="small w-100" /></td>
                    <td><input fesFilterField="updatedAt"class="small w-100" /></td>
                    <td class = "d-none"><input fesFilterField="_rev"class="small w-100" /></td>
                    <!-- <td></td> -->
                </tr>
                <tr *ngFor="let path of filteredPaths;">
                    <td>{{path.id}}</td>
                    <td>{{path.buildingId}}</td>
                    <td>{{path.description}}</td>
                    <td>{{path.updatedAt|date:'yyyy-MM-dd HH:mm:ss'}}</td>
                    <td class = "d-none">{{path._rev}}</td>
                    <!-- <td class="text-center align-middle">
                        <a class="text-nowrap" href="javascript:false;" (click)="editPath(path)">edit</a>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>

</div>
